import React from 'react';
import Button from "../../../gd-components/buttons/gd-button/gd-button-ui5-new";
import {featureRequiredLicenseType} from "../../../gd/access-control/feature-access/feature-access";
import {LicenseType} from "../../../gd/license/license-proto";
import {Feature} from "../../../gd/access-control/feature-access/const";

// const debug = "ModalUpgrade"
const debug = false

type Props = {
    feature?        : Feature
    params?         : {
        feature?        : Feature
    }
}

export default function ModalUpgrade(props:any) {


    const feature = props.feature || props.params.feature

    const onUpgradeClick = () => {
        gd.tempParamsStorage.set('upgrade-feature', feature)
        gd.goTo('o/'+gd.companyId+'/upgrade');
    };


    debug && console.log(debug, "render() feature=", feature)

    const requiredLicenseType: LicenseType = featureRequiredLicenseType(feature)

    let requiredLicenseName = 'Professional'
    switch (requiredLicenseType) {
        case LicenseType.Business:
            requiredLicenseName = 'Business'
            break
        default:
            requiredLicenseName = 'Professional'
            break
    }


    return (
        <div className="modal-upgrade">
            <div className="l1">
                <div className="cont">
                    <img src="/app/web/skin/common/svg/gd-logo.svg" className="logo" />
                    <div className="i5-pro"/>
                </div>
            </div>

            <div className="l2 ui5-title-18">This module requires <strong>{requiredLicenseName} license</strong></div>

            <div className="l3">Upgrade today to access all the premium features and modules:</div>

            <div className="l4">

                <div className="c1">
                    <ul>
                        <li><span className="i5-done"/>Unlimited storage</li>
                        <li><span className="i5-done"/>Up to 250 members</li>
                        <li><span className="i5-done"/>Advanced integrations</li>
                        <li><span className="i5-done"/>Advanced search</li>
                        <li><span className="i5-done"/>User roles customizations</li>
                    </ul>

                </div>
                <div className="c2">
                    <ul>
                        <li><span className="i5-done"/>Advanced views</li>
                        <li><span className="i5-done"/>Big Screens</li>
                        <li><span className="i5-done"/>Advanced time tracking</li>
                        <li><span className="i5-done"/>Reports</li>
                        <li><span className="i5-done"/>Custom fields</li>
                    </ul>

                </div>
                <div className="c3">
                    <ul>
                        <li><span className="i5-done"/>Advanced timeline</li>
                        <li><span className="i5-done"/>Advanced task management </li>
                        <li><span className="i5-done"/>Premium Analytics</li>
                        <li><span className="i5-done"/>Dedicated success manager</li>
                        <li><span className="i5-done"/>And more...</li>
                    </ul>


                </div>
                <div className="cf"/>
            </div>

            <div className="actions flex-row-center-center">
                <Button label="Upgrade now" type="primary" onClick={onUpgradeClick} size="36" className="btn-confirm w-150"/>
            </div>
        </div>
    )

}